

import React from "react"
import { ViewEditBox } from "../ViewEditBox"
import './DroneView.css'
import { ReactComponent as Battery } from '../../../assets/eqtypes/battery.svg';
import { ReactComponent as Carry } from '../../../assets/eqtypes/carry.svg';
import { ReactComponent as Camera } from '../../../assets/eqtypes/camera.svg';
import { ReactComponent as Controller } from '../../../assets/eqtypes/controller.svg';
import { ReactComponent as Drone } from '../../../assets/eqtypes/drone.svg';
import { ReactComponent as Gimbal } from '../../../assets/eqtypes/gimbal.svg';
import { ReactComponent as Sensor } from '../../../assets/eqtypes/sensor.svg';
import { ReactComponent as Len } from '../../../assets/eqtypes/len.svg';
import { ReactComponent as SparePart } from '../../../assets/eqtypes/spare-part.svg';
import { ReactComponent as LandingPad } from '../../../assets/eqtypes/landing-pad.svg';
import { EquipmentType } from "../../../models/hull-models/EuipmentTypes";

export function getSvg (svg, size="medium") {
    svg = svg ? svg : 'controller'
    switch(svg.toLowerCase()) {
        case 'battery':
            return <Battery className={`${size}-icon`} />
        case 'carry':
            return <Carry className={`${size}-icon`}/>
        case 'camera':
            return <Camera className={`${size}-icon`} />
        case 'controller':
            return <Controller className={`${size}-icon`}  />
        case 'drone':
            return <Drone  className={`medium-icon`} />
        case 'gimbal':
            return <Gimbal className={`${size}-icon`} />
        case 'sensor':
            return <Sensor className={`${size}-icon`} />
        case 'lens':
            return <Len className={`${size}-icon`} />
        case 'spare-part':
            return <SparePart className={`${size}-icon`} />
        case 'landing-pad':
            return <LandingPad className={`${size}-icon`} />
        default:
            return <Controller className={`${size}-icon`} />
    }
}

export const EquipmentView = (props) => {
    var serialNumber = props.equip.serial != undefined ? props.equip.serial : ''
    return (
        <div className="drone-item-margin">
            <ViewEditBox {...props} icon={getSvg(new EquipmentType(props.equip.type).getSvgName(), "tiny")} text={props.equip.quantity + 'x - ' + props.equip.type + ' ' + serialNumber} />
        </div>
    )
}